import { memo, ReactNode, useEffect, useState } from 'react'
import clsx from 'clsx'

import { TextOverflow } from '@guidde-co/shared.text-overflow.text-overflow'

import {
    Avatar,
    Box,
    ClickAwayListener,
    Divider,
    Link,
    makeStyles,
    Tooltip,
    Typography,
    TypographyProps
} from '@material-ui/core'

import { EditDescription } from 'UI/Routes/main/common'
import { SpacedGroup } from 'UI/Components'

import { PlaybookType } from 'app/types'
import { useBoolean } from 'hooks'
import { formatDate } from 'modules'

const ViewIcon = () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9998 15.7049C13.1331 15.7049 14.0955 15.3089 14.8868 14.5169C15.6788 13.7255 16.0748 12.7632 16.0748 11.6299C16.0748 10.4965 15.6788 9.53422 14.8868 8.74288C14.0955 7.95088 13.1331 7.55488 11.9998 7.55488C10.8665 7.55488 9.90414 7.95088 9.1128 8.74288C8.3208 9.53422 7.9248 10.4965 7.9248 11.6299C7.9248 12.7632 8.3208 13.7255 9.1128 14.5169C9.90414 15.3089 10.8665 15.7049 11.9998 15.7049ZM11.9998 14.3299C11.2498 14.3299 10.6125 14.0672 10.0878 13.5419C9.56247 13.0172 9.2998 12.3799 9.2998 11.6299C9.2998 10.8799 9.56247 10.2422 10.0878 9.71688C10.6125 9.19222 11.2498 8.92988 11.9998 8.92988C12.7498 8.92988 13.3875 9.19222 13.9128 9.71688C14.4375 10.2422 14.6998 10.8799 14.6998 11.6299C14.6998 12.3799 14.4375 13.0172 13.9128 13.5419C13.3875 14.0672 12.7498 14.3299 11.9998 14.3299ZM11.9998 18.6299C9.6998 18.6299 7.60414 17.9965 5.7128 16.7299C3.8208 15.4632 2.43314 13.7632 1.5498 11.6299C2.43314 9.49655 3.8208 7.79655 5.7128 6.52988C7.60414 5.26322 9.6998 4.62988 11.9998 4.62988C14.2998 4.62988 16.3958 5.26322 18.2878 6.52988C20.1791 7.79655 21.5665 9.49655 22.4498 11.6299C21.5665 13.7632 20.1791 15.4632 18.2878 16.7299C16.3958 17.9965 14.2998 18.6299 11.9998 18.6299ZM11.9998 17.1299C13.8831 17.1299 15.6125 16.6339 17.1878 15.6419C18.7625 14.6505 19.9665 13.3132 20.7998 11.6299C19.9665 9.94655 18.7625 8.60888 17.1878 7.61688C15.6125 6.62555 13.8831 6.12988 11.9998 6.12988C10.1165 6.12988 8.38714 6.62555 6.8118 7.61688C5.23714 8.60888 4.03314 9.94655 3.1998 11.6299C4.03314 13.3132 5.23714 14.6505 6.8118 15.6419C8.38714 16.6339 10.1165 17.1299 11.9998 17.1299Z"
            fill="#090C10"
            fillOpacity="0.6"
        />
    </svg>
)

const RatingIcon = () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.4 10.9299C15.7833 10.9299 16.0957 10.8092 16.337 10.5679C16.579 10.3259 16.7 10.0132 16.7 9.62988C16.7 9.24655 16.579 8.93388 16.337 8.69188C16.0957 8.45055 15.7833 8.32988 15.4 8.32988C15.0333 8.32988 14.725 8.45055 14.475 8.69188C14.225 8.93388 14.1 9.24655 14.1 9.62988C14.1 10.0132 14.221 10.3259 14.463 10.5679C14.7043 10.8092 15.0167 10.9299 15.4 10.9299ZM8.6 10.9299C8.96667 10.9299 9.275 10.8092 9.525 10.5679C9.775 10.3259 9.9 10.0132 9.9 9.62988C9.9 9.24655 9.77933 8.93388 9.538 8.69188C9.296 8.45055 8.98333 8.32988 8.6 8.32988C8.21667 8.32988 7.90433 8.45055 7.663 8.69188C7.421 8.93388 7.3 9.24655 7.3 9.62988C7.3 10.0132 7.421 10.3259 7.663 10.5679C7.90433 10.8092 8.21667 10.9299 8.6 10.9299ZM12 17.3299C13.0333 17.3299 13.9793 17.0465 14.838 16.4799C15.696 15.9132 16.3417 15.1299 16.775 14.1299H15.45C15.1 14.7299 14.625 15.2132 14.025 15.5799C13.425 15.9465 12.75 16.1299 12 16.1299C11.25 16.1299 10.575 15.9465 9.975 15.5799C9.375 15.2132 8.9 14.7299 8.55 14.1299H7.225C7.65833 15.1299 8.30433 15.9132 9.163 16.4799C10.021 17.0465 10.9667 17.3299 12 17.3299ZM12 21.6299C10.6833 21.6299 9.446 21.3799 8.288 20.8799C7.12933 20.3799 6.125 19.7049 5.275 18.8549C4.425 18.0049 3.75 17.0005 3.25 15.8419C2.75 14.6839 2.5 13.4465 2.5 12.1299C2.5 10.8132 2.75 9.57555 3.25 8.41688C3.75 7.25888 4.425 6.25488 5.275 5.40488C6.125 4.55488 7.12933 3.87988 8.288 3.37988C9.446 2.87988 10.6833 2.62988 12 2.62988C13.3167 2.62988 14.5543 2.87988 15.713 3.37988C16.871 3.87988 17.875 4.55488 18.725 5.40488C19.575 6.25488 20.25 7.25888 20.75 8.41688C21.25 9.57555 21.5 10.8132 21.5 12.1299C21.5 13.4465 21.25 14.6839 20.75 15.8419C20.25 17.0005 19.575 18.0049 18.725 18.8549C17.875 19.7049 16.871 20.3799 15.713 20.8799C14.5543 21.3799 13.3167 21.6299 12 21.6299ZM12 20.1299C14.2167 20.1299 16.1043 19.3509 17.663 17.7929C19.221 16.2342 20 14.3465 20 12.1299C20 9.91322 19.221 8.02555 17.663 6.46688C16.1043 4.90888 14.2167 4.12988 12 4.12988C9.78333 4.12988 7.896 4.90888 6.338 6.46688C4.77933 8.02555 4 9.91322 4 12.1299C4 14.3465 4.77933 16.2342 6.338 17.7929C7.896 19.3509 9.78333 20.1299 12 20.1299Z"
            fill="#090C10"
            fillOpacity="0.6"
        />
    </svg>
)
const minimalRatingToShow = 50

const useStyles = makeStyles({
    highlightBorder: {
        borderRadius: 6,
        border: '2px solid #FED243 !important'
    },
    highlightBackground: {
        backgroundColor: '#FEFAE4',
        cursor: 'pointer'
    },
    link: {
        maxWidth: '40vw',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: '#2D9CDB',
        fontSize: '12px',
        textDecoration: 'inherit'
    },
    description: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '12px',
        color: '#828282',
        whiteSpace: 'pre-line'
    }
})

type Props = {
    canEdit?: boolean
    playbook: PlaybookType
    isMobileView?: boolean
    showCreatorTooltip?: boolean
    divider?: boolean
    applications: PlaybookType['applications']
    tags: PlaybookType['tags']
    reactionsComponent?: ReactNode
    onLinkClick?: () => void
    comments?: JSX.Element
}

export const Metadata = memo(
    ({
        canEdit,
        playbook,
        isMobileView,
        reactionsComponent,
        showCreatorTooltip,
        divider = true,
        onLinkClick,
        comments
    }: Props) => {
        const classes = useStyles()

        const { uploadedBy, description, link } = playbook

        const isEmpty = !playbook.uploadedBy?.displayName && !playbook.uploadedBy?.email

        const hover = useBoolean()
        const edit = useBoolean()

        const date = (
            <Caption color={isMobileView ? 'inherit' : 'textSecondary'}>
                {isMobileView ? '• ' : ''}
                {formatDate(playbook.uploadedAt)}
            </Caption>
        )

        const [tempDescription, setTempDescription] = useState(description)

        useEffect(() => {
            setTempDescription(description)
        }, [description])

        return (
            <ClickAwayListener onClickAway={edit.setFalse}>
                <Box
                    width="100%"
                    style={{
                        border: '2px solid transparent'
                    }}
                    className={clsx({
                        [classes.highlightBorder]: hover.isTrue || edit.isTrue,
                        [classes.highlightBackground]: hover.isTrue && edit.isFalse
                    })}
                    onMouseEnter={canEdit ? () => hover.setTrue() : undefined}
                    onMouseLeave={canEdit ? () => hover.setFalse() : undefined}
                    onClick={canEdit ? () => edit.setTrue() : undefined}
                    p={0.5}
                >
                    <Box width="100%" display="flex" justifyContent="space-between">
                        <SpacedGroup
                            spacing={1}
                            width={isMobileView ? '100%' : '30%'}
                            alignItems={isMobileView ? 'center' : 'flex-start'}
                            mt={isMobileView ? 1 : 0}
                        >
                            <Tooltip
                                title={
                                    isEmpty || !showCreatorTooltip ? (
                                        ''
                                    ) : (
                                        <>
                                            {playbook.uploadedBy?.displayName}
                                            <br />
                                            {playbook.uploadedBy?.email}
                                        </>
                                    )
                                }
                            >
                                <Avatar
                                    src={playbook?.userImage}
                                    data-cy="video-user-image"
                                    style={{
                                        width: isMobileView ? 24 : 40,
                                        height: isMobileView ? 24 : 40
                                    }}
                                >
                                    {playbook.username?.slice(0, 1).toUpperCase()}
                                </Avatar>
                            </Tooltip>

                            <Box
                                display="flex"
                                width={isMobileView ? '100%' : 'auto'}
                                flexDirection={isMobileView ? 'row' : 'column'}
                                alignItems={isMobileView ? 'center' : 'flex-start'}
                                justifyContent={isMobileView ? 'space-between' : 'none'}
                            >
                                <SpacedGroup spacing={1}>
                                    <TextOverflow lineClamp={1}>
                                        <Typography
                                            style={{
                                                fontWeight: 500,
                                                fontSize: isMobileView ? 12 : 20
                                            }}
                                            data-cy="video-creator"
                                        >
                                            {uploadedBy.displayName}
                                        </Typography>
                                    </TextOverflow>
                                    {isMobileView && date}
                                </SpacedGroup>
                                <SpacedGroup flexWrap="nowrap" spacing={1}>
                                    {!isMobileView && date}
                                    <SpacedGroup spacing={1}>
                                        {playbook.views !== 0 && (
                                            <SpacedGroup spacing={1}>
                                                <ViewIcon data-cy="video-views-icon" />
                                                <Caption>{playbook.views}</Caption>
                                            </SpacedGroup>
                                        )}
                                        {playbook.rating >= minimalRatingToShow && (
                                            <SpacedGroup spacing={1}>
                                                <RatingIcon data-cy="video-rating-icon" />
                                                <Caption>{playbook.rating}%</Caption>
                                            </SpacedGroup>
                                        )}
                                    </SpacedGroup>
                                </SpacedGroup>
                            </Box>
                        </SpacedGroup>

                        {!isMobileView && (
                            <Box display="flex" justifyContent="flex-end" mb={comments ? 1.5 : 0}>
                                {comments && (
                                    <>
                                        {comments}
                                        <Divider
                                            orientation="vertical"
                                            light={true}
                                            style={{ height: '18px', margin: '12px 0 0 8px' }}
                                        />
                                    </>
                                )}

                                {reactionsComponent}
                            </Box>
                        )}
                    </Box>

                    <SpacedGroup flexDirection="column" spacing={1}>
                        {edit.isTrue ? (
                            <EditDescription
                                value={tempDescription}
                                playbookId={playbook.id}
                                mode={playbook.mode}
                                hideLabel
                                showCharCount
                                charCountPosition="right"
                                multiline
                                maxLength={150}
                                onBlur={setTempDescription}
                            />
                        ) : (
                            <Tooltip
                                placement="top-start"
                                title={<Box whiteSpace="pre-line">{tempDescription}</Box>}
                            >
                                <Box my={isMobileView ? 2 : 0}>
                                    <Typography
                                        className={classes.description}
                                        data-cy="video-description"
                                    >
                                        {tempDescription}
                                    </Typography>
                                </Box>
                            </Tooltip>
                        )}

                        {link && (
                            <Link
                                href={link}
                                className={classes.link}
                                target="_blank"
                                color="inherit"
                                underline="always"
                                onClick={onLinkClick}
                                data-cy="source-url"
                            >
                                <Box title={link}>{link}</Box>
                            </Link>
                        )}
                        {divider && (
                            <Divider style={{ opacity: hover.isFalse && edit.isFalse ? 1 : 0 }} />
                        )}
                    </SpacedGroup>
                </Box>
            </ClickAwayListener>
        )
    }
)

type CaptionProps = {
    children: ReactNode
    dataCy?: string
    color?: TypographyProps['color']
}

const Caption = ({ children, dataCy, color = 'textSecondary' }: CaptionProps) => (
    <Typography variant="caption" color={color} data-cy={dataCy} noWrap>
        {children}
    </Typography>
)
